import styled from 'styled-components'
import { ThemeSelectors } from '@at/design-system-foundation'

export const StyledNewFiltersMobileContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) * 2}px;
`

export const StyledNewLeftColumn = styled.div`
    width: 596px;
`
